<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
@import "./assets/css/style.css";
@import "./assets/css/dark-style.css";
@import "./assets/css/skin-mode.css";
@import "./assets/css/icons.css";
@import "./assets/plugins/sidemenu/sidemenu-1/sidemenu-1.css";
@import "./assets/plugins/sidemenu-responsive-tabs/css/sidemenu-responsive-tabs.css";
@import "./assets/plugins/sidebar/sidebar.css";
@import "./assets/css/color-skins/color15.css";
</style>



// WEBPACK FOOTER //
// src/App.vue